import React from "react";
import { Container, Col } from "react-bootstrap";

const fixed = {
  backgroundImage: `url('https://res.cloudinary.com/universitytix/image/upload/v1600942280/VC_h3fg11.png')`,
};
function CommunityService() {
  return (
    <div>

<div id="resources" className="offset">
        <div className="fixed-background">
          <div className="row dark text-center ">
            <Col sm="12">
              <br />
              <br />
              <br />
              <br />
              <br />
              <h3 className="heading headers">Community/Professional Service</h3>

              <br />
              <br />
              <br />
              <br />
              <div className="heading-underline"></div>
            </Col>
          </div>

          <div className="fixed-wrap">
            <div className="fixed" style={fixed}></div>
          </div>
        </div>
      </div>


      <br />
      <br /> 
      <br />
      <br />
      <Container>
          <h3>(i)Adekunle Ajasin University, Akungba-Akoko</h3>
             
          <br/>
          <li>Chairman, Honours’ Committee of Senate, Adekunle Ajasin University, Akungba-Akoko, 2010 to Date</li>
          <li>Chairman, Strategic Planning Committee, Adekunle Ajasin University, Akungba-Akoko, 2012 to Date</li>
          <li>Chairman, Academic Programmes Committee of Senate, Adekunle Ajasin University, Akungba-Akoko, 2010 toDate</li>
          <li>Chairman, Conference & +Research Grants Committee, Adekunle Ajasin University, Akungba-Akoko, 2010 to Date</li>
          <li>Chairman, Committee on Institutional Accreditation for Adekunle Ajasin University, 2011 to Date</li>
          <li>Chairman, Capital Campaign Committee for Adekunle Ajasin University, Akungba  – Akoko, 2012 to 2013</li>
          <li>Chairman, Bursary Automation Committee, Adekunle Ajasin University, Akungba-Akoko,  2012 to Date</li>
          <li>Chairman, Capital Projects Monitoring Committee, Adekunle Ajasin University, Akungba-Akoko, 10thDecember, 2010 to Date</li>
          <li>Chairman, Implementation Committee for Accreditation, Adekunle Ajasin University, Akungba-Akoko, 2010  to Date</li>
          <li>Chairman, PUTME Screening Committee, Adekunle Ajasin University, Akungba-Akoko, 2012 to Date</li>
          <li>Chairman, Security-sub Committee of Adekunle Ajasin University, Akungba-Akoko, 2013 to Date</li>
          <li>Chairman, Convocation Exhibition Committee of Adekunle Ajasin University, Akungba-Akoko</li>
          <li>Chairman, Budget Committee, Adekunle Ajasin University, Akungba-Akoko, 2010 – Date.</li>
          <li>Chairman, Board of Institute of Education, Adekunle Ajasin University, Akungba – Akoko, 2010 to Date</li>
          <li>Chairman, AAUA-UBEC Training Committee for Teachers & Education Managers in Ondo State, 2012 to Date</li>
          <li>Chairman, Journals Verification Committee, Adekunle Ajasin  University, Akungba – Akoko, 2012 to Date</li>
          <li>Chairman, Committee on Directorate System in the University,  Adekunle   Ajasin University, Akungba – Akoko,  2012</li>
          <li>Chairman, Committee on Criteria/Policy on Prizes & Professorial endowment, Adekunle Ajasin University, Akungba – Akoko, 2010</li>
          <li>Chairman, Committee on the Review of Transcript Administration, 2011 to 2012</li>
          <li>Chairman, Senate Building Allocation Committee, 2014</li>
          <li>Chairman, Academic Staff Audit Committee for Adekunle Ajasin University, Akungba-Akoko, 2013</li>
          <li>Chairman, Committee for Review of Condition of Service for Ajasin University, Akungba-Akoko Staff, 2012-2013</li>
          <li>Chairman, Committee on Review of MoU with School of Basic Studies, Epinmi- Akoko, 2012</li>
          <li>Chairman, Solid Waste  Management Committee in  Adekunle Ajasin University, Akungba – Akoko, 2010 – Date</li>
          <li>Chairman, Fire Policy Development Committee in Adekunle Ajasin University, Akungba –   Akoko, 2010 – Date</li>
          <li>Chairman, Information & Communication Technology Committee, Faculty of  Science, Adekunle Ajasin University , Akungba – Akoko, Nigeria, 2005  -  2008</li>
          <li>Chairman, ICT Infrastructure and Applications Review Committee Adekunle Ajasin University, Akungba – Akoko, Nigeria, 2010 - Date.</li>
          <li>Chairman, Students’ Electoral Committee, Adekunle  Ajasin University, Akungba – AkokoNigeria, 2001</li>
          <li>ember, Governing Council, Adekunle Ajasin University, Akungba-Akoko,  Nigeria, 2008 -  2010 (as Senate Representative)</li>
          <li>Member, Governing Council, Adekunle Ajasin University, Akungba-Akoko,  Nigeria, 2010 to Date</li>
          <li>Member, Interview Panel for recruitment of Lecturers into the Faculty of Science, Achievers University, Owo, Ondo State, 2009</li>
          <li>Member, Council Search Committee for the appointment of Vice-Chancellor of Adekunle Ajasin University , Akungba – Akoko, Nigeria, 2006.</li>
          <li>Member, University ICT Committee, Adekunle Ajasin University, Akungba- Akoko, Nigeria, 2006 – 2008</li>
          <li>Member, Students’ Welfare Board, Adekunle Ajasin University, Akungba – Akoko, 2005  -  2007.</li>
          <li>Member, Development Committee, Adekunle Ajasin University, Akungba-Akoko 2005 -  2008</li>
          <li>Member, Health Centre Committee, Adekunle Ajasin University , Akungba – Akoko, Nigeria, 2005  -  2010</li>
          <li>Member, Post Graduate Board, Adekunle Ajasin University, Akungba-Akoko, 2005 - 2010.</li>
          <li>Member, Examination Malpractices Committee, Faculty of Social and Management Sciences, Adekunle Ajasin University, Akungba-Akoko, Nigeria, 2005 -  2010.</li>
          <li>Member, Committee on the Establishment of Glass of Blowing Laboratory Faculty of Science, Ondo State University, Ado-Ekiti , 1996.</li>
          <li>Member, Faculty Research Grant Committee, Faculty of Science, Adekunle Ajasin University, Akungba – Akoko, Nigeria, 2005 -  2008</li>
          <li>Member, Appointments & Promotions Committee for Junior Staff Adekunle Ajasin University, Akungba-Akoko 2002-2005.</li>
          <li>Member, University Senate 2000 – 2004 and 2007 to Date.</li>
          <li>Member, Strategic Planning Committee Adekunle Ajasin University, Akungba – Akoko 2000 to 2003</li>
          <li>Internal Examiner for M.Sc. Candidate in the Department of Geography & Planning Science,Adekunle Ajasin University, Akungba – Akoko, February 2009</li>
          <li>Seminar Co-ordinator, Faculty of Science, Adekunle Ajasin University, Akungba – Akoko, Nigeria, 2000 to 2008.</li>

          <br/>
          <br/>
          <br/>
          <br/>
          <h3>(ii) Institutions outside Adekunle Ajasin University</h3>

          <li>Coordinator, Research Project for National Space Research and Development Agency (NASRDA),  Abuja, on Sustainable Optimum Cocoa Production in Ondo State Using Remote Sensing and GIS.</li>
          <li>External Examiner to M.Sc. Physics candidate the Postgraduate School, Ladoke Akintola University of Technology, Ogbomosho, May,  2011</li>
          <li>External Examiner to 2 Ph.D.Physics candidates in the Postgraduate School, Ladoke Akintola University of Technology, Ogbomosho, May, 2013</li>
          <li>External Examiner to the Postgraduate School, Federal University of Technology, Ogbomosho, 2015 to date.</li>
          <li>External Assessor to Professorial Candidate,Ladoke Akintola University of Technology,  Ogbomosho, 2012.</li>
          <li>Sabbatical Professor of Physics, Federal University of Oye-Ekiti, Ekiti State, 2015.</li>
          <li>Member, NUC Ad-hoc Accreditation Panel to Oduduwa Univeristy, Ipetumodu, Ile-Ife, Osun State, 2015.</li>
          <li>Chairman, NUC Ad-hoc Accreditation Panel to Godfrey Okoye University and Enugu State University of Science and Technology, 2017.</li>
          <li>External Assessorfor Readership Candidate,in Bells University of Technology,  Ota, Ogun State, 2018</li>
          
          <br/>
          <br/>
          <br/>
          <br/>
          <h3>(iii) Church Organization</h3>

          <li><b>Director</b>, Youth Directorate, Apostolic Faith Church, Ado-Ekiti Region,  (Comprising Ondo, Ekiti & Osun  states),  2011-2013</li>
          <li><b>Minister</b>, Apostolic Faith Church, 1996 to Date</li>
          <li><b>Secretary</b>, Apostolic Faith Church Development Committee,  Ado-Ekiti, 2003-2005</li>
          <li><b>Member</b>, Association of Visiting Secretaries, Lagos, 1987 to Date</li>
          <li><b>Member</b>, Senior Choir, Apostolic Faith Mission, Africa Headquarters, Anthony Village, Lagos, 1991 to Date</li>
   
          <br/>
          <br/>   
          <br/>
          <br/>   
          <br/>
          <br/>   
          
      </Container>

    </div>
  );
}
export default CommunityService;
